<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ptnum" id="pt1">
<a id="page_1">PART ONE</a></h1><a id="page_1">
<h1 class="pttitle">The Book of the King of Dreams</h1>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Part01.vue?61480182